import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import { CitiesInfoContext } from '../../AllCitiesContext';
import AuthClient from '../../api/AuthClient';
import GetAllCitiesApi from '../../api/GetAllCitiesApi';
import { parseCitiesResponse } from '../../api/parseResponse/parseAllCitiesResponse';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { UserProfileInfoContext } from '../../GlobalContext/UserProfileInfoContext';
import { getCurrentCity, setStoredCurrentCity } from '../../utils/currentCity';

const CitySelector: React.FC = () => {

  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [cityName, setCityName] = useState<string>("");

  const { userProfileInfo } = useContext(UserProfileInfoContext);
  const { citiesInfo, setSelectedCity, setAllCitiesContextData } = useContext(CitiesInfoContext);

  const authClient = new AuthClient();
  const authenticationResponse = authClient.getAuthenticationResponse();
  const authenticationCityId = authenticationResponse?.cityId;
  const authenticationCityName = authenticationResponse?.cityName;
  const userInfo = userProfileInfo[0]

  const allCities = citiesInfo[0]?.allCities ?? [];
  const filteredCities = allCities
    .filter(city => city.Name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => a.Name.localeCompare(b.Name));
  
  const cityIdToCheck = userInfo?.CityId !== undefined && userInfo?.CityId !== null ? userInfo?.CityId : authenticationResponse?.cityId;
  const profileCity = allCities.find(city => city.Id === cityIdToCheck);

  useEffect(() => {
    if (citiesInfo.length > 0) return;

    const client = new AuthClient();
    const getAllCitiesApi = new GetAllCitiesApi(client);
    getAllCitiesApi.getAllCities()
      .then((response) => {
        const data = response.data;
        if (Array.isArray(data) && data.length > 0) {
          const parsedData = parseCitiesResponse(data);
          setAllCitiesContextData([parsedData]);
        }
      })
      .catch((err) => console.error("Error fetching cities", err));
  }, [citiesInfo.length, setAllCitiesContextData]);

  const storeCity = (cityName: string, cityId: string) => {
    setSelectedCity(cityName);
    setStoredCurrentCity({ cityName, cityId });

    navigate(-1);
  }

  useEffect(() => {
    const authenticationCity =
      authenticationCityId && authenticationCityName
        ? { cityId: authenticationCityId, cityName: authenticationCityName }
        : undefined;
    const currentCity = getCurrentCity(authenticationCity);
    if (currentCity) {
      setCityName(currentCity.cityName);
      return;
    }

    if (profileCity?.Name) {
      setCityName(profileCity.Name);
    }
  }, [authenticationCityId, authenticationCityName, profileCity?.Name]);

  return (
    <>
      <Header />
      <div className="centerGroup">
        <div className='desktopUI'>

          <Breadcrumbs />

          <input
            className='citySearchBar'
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type a city name..."
            disabled={allCities.length === 0}
          />

          {allCities.length === 0 && (
            <p className="text-white m-4">Loading cities...</p>
          )}

          {filteredCities.map((city, index) => (
            <div
              className='d-flex m-4 yellowTxt cityList'
              key={index}
              onClick={() => storeCity(city.Name, city.Id)}
            >
              {city.Name}

              {(cityName === city.Name) &&
                <span className='text-white text-height'>
                  Your current city
                </span>
              }
            </div>
          ))}

          <button className="voteCity">Vote for other City</button>
        </div>
      </div>
    </>
  );
};

export default CitySelector;
